import type { FaireProductEntity } from "../../entity_types/product";

export const p_xdxymwmsv8: FaireProductEntity = {
  token: "p_xdxymwmsv8",
  type: "product",
  name: "Clifton Hanging Plant Pot Medium",
  brandToken: "b_dtfc7uc37e",
  brandName: "Aaron Probyn US",
  imageUrl: "https://cdn.faire.com/fastly/1734c1ef87c42bc107ee25c560450b96509eada47a6c32b72325438da6c4a88b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/30c548bde7c1b338fe4540a1a227f443f9963e4eae3a55da4a651032b3692175.jpeg",
    "https://cdn.faire.com/fastly/3845ff4e1805336e1a6d4d3b5afa2f4f3d4a71ac43a55b4835d81a7e919012c7.jpeg",
    "https://cdn.faire.com/fastly/99600b0d40aa6efa5f87c899688ab4ea3fc5589ba2a8ed37b81aeb0f8555cb53.jpeg",
    "https://cdn.faire.com/fastly/692df5f41a90427aa84cc24ccd0a61b87fa1983ee11d91f332f03a992623f282.jpeg",
    "https://cdn.faire.com/fastly/48da907360ad75bfff109eefb06c06ff646bb6ed651e4f91a49bf53b04d08185.jpeg"
  ],
  priceDollars: 37.5,
  description: "CLIFTON plant pots have been specifically designed to suspend your favourite hanging plants. They work beautifully on their own or more dramatically with several clustered together to create an eye-catching sculptural display. Hanging plants are great for filling empty spaces in your home or office and lifting plants off the floor, especially when space is limited. The soft form of the planter together with the rich colours and matt finish pair beautifully with the greenery. A uniquely designed hanging mechanism allows you to easily remove the pots to water or to rearrange as your plant matures.\n\n𝐌𝐞𝐝𝐢𝐮𝐦\n• Dimensions: Ø 20.8 x 15.1 cm\n• Material: stainless steel\n\n• The set includes the hanging mechanism",
  tags: [],
  msrpDollars: 75,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-04T23:53:22.687Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
